import angular from 'angular';
import { createElement } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { BackgroundEffectsModal } from '../components/background-effects';
import { withProviders } from '../../core/components';
export default angular
    .module('doxy.videoChat.backgroundEffects', [])
    .component('backgroundEffects', {
    controller: class {
        constructor($element) {
            this.$element = $element;
        }
        $onInit() {
            render(createElement(withProviders(BackgroundEffectsModal)), this.$element[0]);
        }
        $onDestroy() {
            unmountComponentAtNode(this.$element[0]);
        }
    },
}).name;
